import type { Params } from '@angular/router';
import type { RouterState } from './router.type';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import * as RouterSelectors from './router.selectors';

@Injectable()
export class RouterFacade {
    private readonly store = inject(Store);

    public readonly routerState$: Observable<RouterState> = this.store.select(RouterSelectors.selectRouterState);
    public readonly routerParams$: Observable<Params> = this.store.select(RouterSelectors.selectRouterParams);
    public readonly routerUrl$: Observable<string> = this.store.select(RouterSelectors.selectRouterUrl);
    public readonly routerQueryParams$: Observable<Params> = this.store.select(RouterSelectors.selectRouterQueryParams);
}
